import { Navigate, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/app/settings/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate from={Route.fullPath} to="./file-types" />
}
